// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2L4v5","bigColWidth":"Table_bigColWidth__1eoh2","biggerColWidth":"Table_biggerColWidth__31yS-","row":"Table_row__1Grl4","col":"Table_col__1x-Zd"};